module.exports = __webpack_public_path__ + "static/logo@1.5x-9b82f3d83dda12e03fabd81ff795a88c.png";